import { render, staticRenderFns } from "./PortfolioDashboard.html?vue&type=template&id=104c9c00&scoped=true&"
import script from "./PortfolioDashboard.js?vue&type=script&lang=js&"
export * from "./PortfolioDashboard.js?vue&type=script&lang=js&"
import style0 from "./PortfolioDashboard.scss?vue&type=style&index=0&id=104c9c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c9c00",
  null
  
)

export default component.exports